export const PERMISSION_KEYS = [
    "submitPoints",
    "viewScores",
    "viewAllSubmissions",
    "manageSubmissions",
    "approveSubmissions",
    "manageStaff",
    "manageCategories",
    "manageWeeks",
    "manageCabins",
    "manageSettings",
    "runBulkOperations",
    "generateReports",
    "viewAuditLog"
];
export const DEFAULT_STAFF_PERMISSIONS = {
    submitPoints: true,
    viewScores: false,
    viewAllSubmissions: false,
    manageSubmissions: false,
    approveSubmissions: false,
    manageStaff: false,
    manageCategories: false,
    manageWeeks: false,
    manageCabins: false,
    manageSettings: false,
    runBulkOperations: false,
    generateReports: false,
    viewAuditLog: false
};
export const DEFAULT_ADMIN_PERMISSIONS = {
    submitPoints: true,
    viewScores: false,
    viewAllSubmissions: true,
    manageSubmissions: true,
    approveSubmissions: true,
    manageStaff: true,
    manageCategories: true,
    manageWeeks: true,
    manageCabins: true,
    manageSettings: true,
    runBulkOperations: true,
    generateReports: true,
    viewAuditLog: true
};
export function mergePermissions(base, overrides) {
    return {
        ...base,
        ...(overrides ?? {})
    };
}
